__turbopack_context__.v({
  "InlineSelectorWrapper": "uBRRtG_InlineSelectorWrapper",
});
